export type FolderTreeInput = {
  basename?: string
  storageLink?: string
  subFolder?: Array<FolderTreeInput>
}

export type FolderTreeNode = {
  label: string
  value: string
  children?: Array<FolderTreeNode>
}

const toShallowNode = (item: FolderTreeInput): FolderTreeNode => ({
  label: item.basename ?? '',
  value: item.storageLink ?? '',
  ...(item.subFolder && item.subFolder.length > 0 ? {children: []} : {}),
})

/**
 * Builds only the root node plus one level of shallow children. Deeper
 * levels are loaded on demand via getFolderChildren (rsuite's CheckTree
 * getChildren hook) instead of materializing the whole hierarchy up front,
 * since the media library can hold thousands of nested folders.
 */
export const buildFolderTree = (root: FolderTreeInput): Array<FolderTreeNode> => [
  {
    ...toShallowNode(root),
    ...(root.subFolder && root.subFolder.length > 0
      ? {children: root.subFolder.map(toShallowNode)}
      : {}),
  },
]

const findFolderNode = (root: FolderTreeInput, storageLink: string): FolderTreeInput | undefined => {
  if (root.storageLink === storageLink) return root
  for (const child of root.subFolder ?? []) {
    const found = findFolderNode(child, storageLink)
    if (found) return found
  }
  return undefined
}

export const getFolderChildren = (
  root: FolderTreeInput,
  storageLink: string
): Array<FolderTreeNode> => {
  const node = findFolderNode(root, storageLink)
  return (node?.subFolder ?? []).map(toShallowNode)
}
